export const isValidUrl = (url) => {
  return (
    !!url &&
    (url.startsWith("/") ||
      url.startsWith("http://") ||
      url.startsWith("https://"))
  );
};
